'use strict';

var mediator = require('../mediator'),
  _ = require('underscore'),
  $ = require('jquery'),
  events = require('../config').events,
  classes = require('../config').classes,
  utilities = require('../utilities'),
  FormView = require('../../components/Form/FormView'),
  ModalView = require('./ModalView'),
  shareEmailModalTemplate = require('../../tmpl/client/modal/shareEmailModal.hbs'),

  // This is currently not being used as email share is not enabled
  // In order to use, trigger events.share.email
  ShareModalView = ModalView.extend({

    template: shareEmailModalTemplate,

    initialize: function() {
      _.bindAll(this, 'initializeElements', 'initializeEvents', 'onSubmit', 'loading', 'onSubmitSuccess', 'onSubmitFailed');

      ShareModalView.__super__.initialize.apply(this);

      mediator.on(events.share.email, this.open);
      mediator.on(events.share.email, this.initializeElements);
      mediator.on(events.share.email, this.initializeEvents);
    },

    initializeElements: function() {
      this.$form = this.$('form');
      this.$title = this.$('.Modal-header-title');
      this.$shareContainer = this.$('.Modal-container');
      this.$name = this.$('#share-form-name');
      this.$toEmail = this.$('#share-form-toEmail');
    },

    initializeEvents: function() {
      var self = this;

      this.formView = new FormView({
        el: this.$form
      });

      this.formView.$el.on('submit', self.onSubmit);
    },

    onSubmit: function() {
      var data = {
        name: this.$name[0].value,
        toEmail: this.$toEmail[0].value,
        shareLink: this.modalData.shareLink
      };

      // When the form is valid
      if (!this.formView.validator.numberOfInvalids()) {
      // Create a promise object to start an ajax call
        var promise = $.ajax(this.formView.$el.attr('action'), {
          dataType: 'json',
          method: 'post',
          data: utilities.addCustIpToDataObject(data),
          beforeSend: this.loading
        });

        // Process response with callbacks
        promise.done(this.onSubmitSuccess);
        promise.fail(this.onSubmitFailed);
      }

      return false;
    },

    loading: function() {
      var self = this;

      this.timeout = setTimeout(function() {
        self.$title.html('Sharing product...');
        self.$shareContainer.html('<span></span>');
        self.$shareContainer.addClass(classes.loadingClass);
      }, 1000);
    },

    onSubmitSuccess: function() {
      clearTimeout(this.timeout);
      // When the form is successfully submitted, display message
      this.$shareContainer.removeClass(classes.loadingClass);
      this.$title.html('Product has been shared');
      this.$shareContainer.html('<p>Product link has been shared.</p>');
    },

    onSubmitFailed: function(res) {
    // When the form has errors display messages
      if (res.responseJSON && res.responseJSON.errors) {
        var errors = res.responseJSON.errors;
        for (var i = 0; i < errors.length; i++) {
          var error = errors[i];
          this.$('#' + error.id).addClass('is-invalid');
        }
      }
    }
  });

module.exports = new ShareModalView();



// WEBPACK FOOTER //
// ./assets/js/components/ShareEmailModalView.js